const getVersionHeader = () => {
  const version = process.env.REACT_APP_VERSION?.trim();

  return version
    ? {
        'X-Performa-UX-Version': version,
      }
    : {};
};

export default getVersionHeader;
